<template>
  <div id="app">
    <div>
      <transition name="fade">
        <Carregando v-show="carregando" />
      </transition>
      <div v-show="!carregando">
        <Header />

        <router-view></router-view>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import Carregando from "@/components/layout/Carregando.vue";
import axios from "axios";

export default {
  name: "App",

  components: {
    Footer,
    Carregando,
    Header,
  },

  data() {
    return {
      carregando: true,
    };
  },

  mounted() {

    axios.get("http://localhost/instagram-teste/teste.php")
    .then((response) => {
      console.log(response.data.graphql.hashtag.edge_hashtag_to_media.edges);

    });


    setTimeout(() => {
      this.carregando = false;
    }, 1500);
  },
};
</script>

<style lang="scss">
.modal-content {
  border: 0px !important;
  border-radius: 1.2rem !important;
  box-shadow: 0 5px 20px 0 rgba(69, 67, 96, 0.05);
  padding: 0.85rem;

  .modal-header {
    border-bottom: 0px;
  }

  .modal-footer {
    border-top: 0px !important;
    border-bottom-right-radius: 1.2rem !important;
    border-bottom-left-radius: 1.2rem !important;
  }

  h5 {
    font-weight: 800;
  }
}

.modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto;
}
[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
    cursor: pointer;
}
button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
}
.close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

</style>